import { Hub } from '../types/hub';
import { plain } from './cardFacts';

export type HubSort = 'name' | 'newest' | 'oldest' | 'resources';

export const HUB_SORT_OPTIONS: Array<{ value: HubSort; label: string }> = [
  { value: 'name', label: 'Name (A–Z)' },
  { value: 'newest', label: 'Date added (newest)' },
  { value: 'oldest', label: 'Date added (oldest)' },
  { value: 'resources', label: 'Most resources' },
];

export function parseHubSort(value: string | null): HubSort {
  if (value === 'newest' || value === 'oldest' || value === 'resources' || value === 'name') {
    return value;
  }
  return 'name';
}

export function hubHasDocuments(hub: { resources?: unknown[] }): boolean {
  return (hub.resources?.length ?? 0) > 0;
}

export function hubMatchesQuery(hub: Hub, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    hub.title.toLowerCase().includes(q) ||
    hub.slug.toLowerCase().includes(q) ||
    plain(hub.description).toLowerCase().includes(q) ||
    (hub.sections ?? []).some((section) => section.title.toLowerCase().includes(q))
  );
}

export function filterHubs(hubs: Hub[], query: string): Hub[] {
  return hubs.filter((hub) => hubMatchesQuery(hub, query));
}

export function programMatchesQuery(
  program: {
    title: string;
    introduction?: string | null;
    sections?: Array<{ title: string }>;
    hubs?: Array<{ title: string }>;
  },
  query: string
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    program.title.toLowerCase().includes(q) ||
    (program.introduction || '').toLowerCase().includes(q) ||
    (program.sections ?? []).some((section) => section.title.toLowerCase().includes(q)) ||
    (program.hubs ?? []).some((hub) => hub.title.toLowerCase().includes(q))
  );
}

export function sortHubs(hubs: Hub[], sort: HubSort): Hub[] {
  const list = [...hubs];
  switch (sort) {
    case 'newest':
      return list.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    case 'oldest':
      return list.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
    case 'resources':
      return list.sort((a, b) => (b.resources?.length ?? 0) - (a.resources?.length ?? 0));
    case 'name':
    default:
      return list.sort((a, b) => a.title.localeCompare(b.title));
  }
}
